import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { AuthWrapper } from "../../components/forms/auth";
import { SumsubWebSdkWrapper } from "../../components/forms/kyc/SumsubWebSdkWrapper";
import AuthLayout from "../../layouts/Auth.layout";
import { useKycMutation } from "../../store/services/auth";
import { errorsFromResponse } from "../../utils/errors";

export const AnonKYCPage: FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const jwt = searchParams.get("jwt") || "";

  const [getKycToken, { data, isError, error, reset }] = useKycMutation();

  useEffect(() => {
    // Reset request on unmount to get new token on each mount (like clear cache)
    return () => reset();
  }, [reset]);

  useEffect(() => {
    if (jwt && !data) {
      (async () => {
        await getKycToken({ jwt });
      })();
    }
  }, [data, getKycToken, jwt]);

  const form = (
    <SumsubWebSdkWrapper
      token={data?.token || ""}
      errors={isError ? errorsFromResponse(error) : []}
    />
  );

  return (
    <AuthLayout>
      <AuthWrapper form={form}>
        <h2 className="font-poppins text-gray-500 text-4xl font-bold mb-6">
          Verify identity
        </h2>
      </AuthWrapper>
    </AuthLayout>
  );
};
